var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loucengfenbu"},[_c('img',{staticClass:"no-patient-pic",attrs:{"src":require("@/assets/images/no-content.png"),"alt":""}}),_c('p',[_vm._v("暂无数据")])])
}]

export { render, staticRenderFns }